/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { CommentRect2TextIcon16Light } from './CommentRect2TextIcon16Light';
import { CommentRect2TextIcon16Regular } from './CommentRect2TextIcon16Regular';
import { CommentRect2TextIcon16Solid } from './CommentRect2TextIcon16Solid';
import { CommentRect2TextIcon20Light } from './CommentRect2TextIcon20Light';
import { CommentRect2TextIcon20Regular } from './CommentRect2TextIcon20Regular';
import { CommentRect2TextIcon20Solid } from './CommentRect2TextIcon20Solid';
import { CommentRect2TextIcon24Regular } from './CommentRect2TextIcon24Regular';
import { CommentRect2TextIcon24Solid } from './CommentRect2TextIcon24Solid';
import { CommentRect2TextIcon32Regular } from './CommentRect2TextIcon32Regular';
import { CommentRect2TextIcon64Regular } from './CommentRect2TextIcon64Regular';
var sizes = {
    16: {
        light: CommentRect2TextIcon16Light,
        regular: CommentRect2TextIcon16Regular,
        solid: CommentRect2TextIcon16Solid,
    },
    20: {
        light: CommentRect2TextIcon20Light,
        regular: CommentRect2TextIcon20Regular,
        solid: CommentRect2TextIcon20Solid,
    },
    24: {
        regular: CommentRect2TextIcon24Regular,
        solid: CommentRect2TextIcon24Solid,
    },
    32: {
        regular: CommentRect2TextIcon32Regular,
    },
    64: {
        regular: CommentRect2TextIcon64Regular,
    },
};
export var CommentRect2TextIcon = forwardRef('CommentRect2TextIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
